import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { rem } from 'polished';
import { NotReadyToBuyOnlineStyled } from '../NotReadyToBuyOnlineStyled';
export const NotReadyToBuyOnlineStyledDS = styled(NotReadyToBuyOnlineStyled)`
    background: ${({ theme }) => theme.colors.grey4};

    @media (min-width: ${breakpoints.sm}px) {
        border-radius: ${rem('8px')};
    }

    .title {
        font-size: ${rem('22px')};
    }

    .container {
        .wrapper {
            .innerTitle {
                .titleContent {
                }
                .icon {
                    .icon-wrapper,
                    svg {
                    }
                }
            }

            .innerContent {
                color: black;
                line-height: 1.25;

                .linkButton {
                    border: unset;
                    text-align: left;
                    padding: unset;
                    font-weight: bold;
                    font-size: ${rem('16px')};
                    margin-top: ${rem('16px')};
                    color: black;
                    background: unset;
                    cursor: pointer;

                    .txt {
                        margin-right: ${rem('7px')};
                    }

                    .icon-wrapper {
                        svg path {
                            fill: black !important;
                            stroke: black !important;
                        }
                    }

                    &:hover {
                        color: ${({ theme }) => theme.colors.primary};

                        .icon-wrapper {
                            svg path {
                                fill: ${({ theme }) => theme.colors.primary} !important;
                                stroke: ${({ theme }) => theme.colors.primary} !important;
                            }
                        }
                    }
                }

                .innerContentTxt {
                    .contentItem {
                    }
                }
            }
        }
    }
`;
